/**
 * Estados de D-Talk — UNA definición para backend (dtalk-dynamo.ts) y frontend
 * (dtalkShared.ts), que tenían la misma unión copiada (auditoría 18/09/2026).
 * §13 del doc: los "No elegible - X" son processStatus 'not_eligible' +
 * eligibilityStatus con el motivo.
 */
export const DTALK_PROCESS_STATUSES = [
  'not_started',        // Sin iniciar
  'in_progress',        // En curso
  'paused',             // Pausada
  'pending_validation', // Conclusión pendiente de validación
  'completed',          // Completada
  'reopened',           // Reabierta
  'closed_window',      // Cerrada por fin de ventana
  'not_eligible',       // No elegible (motivo en eligibilityStatus)
] as const;
export type DTalkProcessStatus = (typeof DTALK_PROCESS_STATUSES)[number];

/** §7 — elegibilidad. */
export const DTALK_ELIGIBILITIES = ['eligible', 'onboarding', 'license', 'inactive'] as const;
export type DTalkEligibility = (typeof DTALK_ELIGIBILITIES)[number];

/** §15.3 — claridad de la conversación. */
export const DTALK_CLARIDADES = ['Alta', 'Media', 'Baja'] as const;
export type DTalkClaridad = (typeof DTALK_CLARIDADES)[number];

export const DTALK_IDIOMAS = ['es', 'pt', 'en'] as const;
export type DTalkIdioma = (typeof DTALK_IDIOMAS)[number];

/**
 * Tope de caracteres de un mensaje de la conversación (zod del handler y del
 * procedure tRPC, y `maxLength` del cuadro de texto).
 *
 * Vivía suelto como `max(3000)` en los dos schemas del backend y en ninguna
 * parte del front: alguien escribía una respuesta larga —o la dictaba, que es
 * donde se pasa sin darse cuenta— y al enviar se comía un "D-Talk: error 400"
 * sin motivo, con un botón "Reintentar" que iba a fallar siempre (01/10/2026).
 *
 * **6000 desde el 02/10/2026** (Sol: "subir el tope"), que son ~1.000 palabras
 * por mensaje y el techo más alto que ya usaba el repo (el chat del Brain y el
 * intake de TA). No más que eso porque al modelo le van los últimos 30 mensajes
 * (`MODEL_HISTORY_CAP` en lib/dtalk-process-message.ts): el tope multiplica el
 * contexto de cada turno, así que subirlo cuesta tokens y latencia en charlas
 * largas. Si alguien vuelve a chocar contra 6000, ahora lo ve venir con el
 * contador en vez de comerse un error.
 *
 * **Si cambiás este número**, actualizá también el check
 * "dtalk-message con un mensaje más largo que el tope" de
 * `scripts/staging-bot/checks.json`: manda `tope + 1` caracteres y espera el
 * 400. Con el número viejo el smoke se pone rojo —así se descubrió la primera
 * vez— y encima gasta un turno real de Bedrock, porque el mensaje pasa.
 */
export const DTALK_MAX_MESSAGE_CHARS = 6000;
